import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: "/eingA1",
    name: "EingA1",
    component: () => import("../views/EingA1.vue")
  },
  {
    path: "/eingA2",
    name: "EingA2",
    component: () => import("../views/EingA2.vue")
  },
  {
    path: "/eingA3",
    name: "EingA3",
    component: () => import("../views/EingA3.vue")
  }
]

const router = new VueRouter({
  routes
})

export default router
